import React, { useEffect, useContext, useState } from 'react';
import './PlayerSelectionScreen.css';
import '../src/styles/font.css';
import { ScreenContext } from './App';
import selectionBG from './Assets/Images/AppDashboard/PlayerSelectionScreen/selectionBG.png';
import descreaseeBtn from './Assets/Images/AppDashboard/PlayerSelectionScreen/decreaseBtn.png';
import increaseBtn from './Assets/Images/AppDashboard/PlayerSelectionScreen/increaseBtn.png';
import playerProfile from './Assets/Images/AppDashboard/HomeScreen/PlayerProfile.png';

import onToggle  from './Assets/Images/AppDashboard/PlayerSelectionScreen/OnToggle.png'
import offToggle from './Assets/Images/AppDashboard/PlayerSelectionScreen/OffToggle.png'
import nextBtn  from './Assets/Images/AppDashboard/PlayerSelectionScreen/nextBtn.png'
import LobbyScreen from './LobbyScreen';
import {handleZIndexChangeLobbyExport, InitializeLobbyDataExport} from './LobbyScreen';

import Loading from './Loading';
import {handleZIndexChangeLoadingExport } from './Loading';

let setSelectedGameModeExport;
let handleZIndexChangeExport;



const PlayerSelectionScreen = () => {

    

    const [zIndex, setZIndex] = useState(-999); // Initial z-index value
    const [selectedPlayersCount, setselectedPlayersCount] = useState(2);
    const handleScreenChange = useContext(ScreenContext);

    const [selectedGameMode, setSelectedGameMode] = useState('');

    const [allowMatchToggle, setAllowMatchToggle] = useState(offToggle);
    const [manualPlacementToggle, setManualPlacementToggle] = useState(offToggle);

    console.log(`Game Mode Player Selection Screen ====> ${selectedGameMode}`);

    useEffect(() => {

      if (selectedGameMode !== '') {
  
        console.log('Hiding Loading Screen');
        handleZIndexChangeLoadingExport();
      }
    }, [selectedGameMode]);

    const BACK = () => {
        handleZIndexChangeLoadingExport();
        handleScreenChange('Home'); // Change to the 'Game' screen
    };

    
    const PlayGame = async () => {
      
      handleZIndexChange();
      handleZIndexChangeLoadingExport();
      // Wait for the screen change to complete
      await handleScreenChange('Lobby')//handleScreenChange('Game');
      handleZIndexChangeLobbyExport();
      InitializeLobbyDataExport(selectedPlayersCount, selectedGameMode);
      console.log(`Selected Game Mode ====> ${selectedGameMode} || Selected Players ====> ${selectedPlayersCount} || Player Selection Screen`);

    }

    const handleAllowMatchToggle = () => {
      if(allowMatchToggle === onToggle){
        setAllowMatchToggle(offToggle);
      }else{
        setAllowMatchToggle(onToggle);
      }
    }

    const handleManualPlacementToggle = () => {
      if(manualPlacementToggle === onToggle){
        setManualPlacementToggle(offToggle);
      }else{
        setManualPlacementToggle(onToggle);
      }
    }

    const handlePlayersCountDecrease = () => {
      console.log('Decrease');
      updatetPlayersCount(false);
    };
      
    const handlePlayersCountIncrease = () => {
      console.log('Increase');
      updatetPlayersCount(true);
    };


    const updatetPlayersCount = (isIncrease) => {

        console.log('Selected Players Count Value Increased');
    
        if(isIncrease){
          if(selectedPlayersCount === 6){
            setselectedPlayersCount(2);
          }else{
            setselectedPlayersCount(selectedPlayersCount+1);
          }
    
        }else{
    
          if(selectedPlayersCount === 2){
            setselectedPlayersCount (6);
          }else{
            setselectedPlayersCount(selectedPlayersCount-1);
          }
        }
    
        console.log(`TSelected Players Count Value  ====> ${selectedPlayersCount}`);    

    }

    const handleZIndexChange = (isAutoPlayDice) => {
    
     // console.log('Handle Z Index is Called || Player Selecion Screen');
      // Change the z-index value
      setZIndex(prevZIndex => prevZIndex === 999 ? -999 : 999);
  
      //console.log(`Player Selection Screen ZIndex ====> ${zIndex}`);
    };


    setSelectedGameModeExport = setSelectedGameMode;
    handleZIndexChangeExport = handleZIndexChange;


    return (

        <div className="player-selection-screen" style={{ zIndex }}>

        <div>
          {/* LoadingScreen */}
          {<Loading/>}
        </div>

            {/* Your Logo and other elements */}
            <div className="player-selection-wrapper" style={{width:"60%"}}>

                <img
                    src={require('./Assets/Images/AppDashboard/PlayerSelectionScreen/PlayerSelectionScreenPanel.png')}
                    alt="PlayerSelectionScreenPanel"
                    className="player-selection-panel"
                />

                 <img
                    src={require('./Assets/Images/AppDashboard/backBtn.png')}
                    alt="backBtn"
                    style={{ width: '3%', height: 'auto', position: 'absolute', top: '13%', left: '85%', transform: 'translate(-50%, -50%)' }}
                    onClick={BACK}
                />   

                <img
                    src={require('./Assets/Images/AppDashboard/PlayerSelectionScreen/Seprator.png')}
                    alt="Seprator"
                    style={{ width: '65%', height: 'auto', position: 'absolute', top: '32%', left: '50%', transform: 'translate(-50%, -50%)' }}

                />  

                <div className="title" style={{ position: 'absolute', bottom: '60%', left: '50%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', fontFamily: 'Gomarice',  color: 'white', fontSize: '1.8vw'}}>NUMBER OF PLAYERS</div>       

                

                <div className="player-selection-bar" style={{ position: 'absolute', top: '43%', left: '50%', transform: 'translateX(-50%)', width: '20%', height: '10%', zIndex: 3 }}>
                    <div className="selection-bg" style={{ position: 'relative', width: '100%', height: '100%' }}>
                        <img src={selectionBG} alt="Centered Image" style={{ width: '100%', height: '100%' , position:'absolute' }} />
                        <img src={descreaseeBtn} alt="Left Image" className="roll-btn left" style={{ position: 'absolute', top: '50%', left: '5%', transform: 'translate(-50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handlePlayersCountDecrease} />
                        <img src={increaseBtn} alt="Right Image" className="roll-btn right" style={{ position: 'absolute', top: '50%', right: '5%', transform: 'translate(50%, -50%)', width: '20%', height: 'auto', zIndex: 4 }} onClick={handlePlayersCountIncrease}/>
                        <div className="roll-text" style={{ position: 'absolute', top: '10%', left: '50%', transform: 'translateX(-50%)', zIndex: 4, fontWeight: 'bold', color: 'white', fontSize: '2.5vw', fontFamily: 'Gomarice' }}>{selectedPlayersCount}</div>
                    </div>
                </div>

                <div className="rematch-toogle-bar" style={{ position: 'absolute', top: '63%', left: '30%', transform: 'translateX(-50%)', width: '30%', height: '10%', zIndex: 3 }}>
                    <div className="toggle-bg" style={{ position: 'relative', width: '100%', height: '100%' }}  onClick = {handleAllowMatchToggle}>

                    <div className="title" style={{ position: 'absolute', bottom: '60%', left: '60%', width: '90%', height: 'auto', transform: 'translateX(-50%)', zIndex: 4, fontFamily: 'Gomarice', fontWeight: 'bold', color: 'white', fontSize: '1.5vw'}}>ALLOW REMATCH</div>

                        <img src={allowMatchToggle} alt="Centered Image" style={{ position: 'absolute', top: '60%', left: '25%', width: '30%', height: 'auto' }} />
                        
                    </div>
                </div>

                <div className="rematch-toogle-bar" style={{ position: 'absolute', top: '63%', right: '0%', transform: 'translateX(-50%)', width: '30%', height: '10%', zIndex: 3 }}>
                    <div className="toggle-bg" style={{ position: 'relative', width: '100%', height: '100%' }} onClick = {handleManualPlacementToggle}>
                        <div className="title" style={{ position: 'absolute', bottom: '60%', left: '55%', width: '98%', height: 'auto', transform: 'translateX(-50%)', zIndex: 4, fontFamily: 'Gomarice', fontWeight: 'bold', color: 'white', fontSize: '1.5vw' }}>MANUAL PLACEMENT</div>
                        <img src={manualPlacementToggle} alt="Centered Image" style={{ position: 'absolute', top: '60%', left: '25%', width: '30%', height: 'auto' }} />
                     </div>
                </div>


                <img src={nextBtn} alt="Next Button" style={{ position: 'absolute', top: '85%', left: '42.5%', width: '15%', height: 'auto' }} onClick={PlayGame} />
               
            </div>
        </div>
    );

}

export {setSelectedGameModeExport, handleZIndexChangeExport};
export default PlayerSelectionScreen;